// NOTE: dont export outside package scope

import { createContext, useContext } from 'react'

import { createPromptsStore } from './promptsStore'

/**
 * `Prompts` is also rendered without an `IndependentPrompts` above it, so the
 * default value is one module-wide store shared by every such tree.
 */
export const PromptsContext = createContext(createPromptsStore())

PromptsContext.displayName = 'PromptsContext'

export const usePromptsStore = () => useContext(PromptsContext)
